export default "__VITE_ASSET__D3y7Q2GU__"